import { IProduktdefinition } from "./IProduktdefinition";
import { ProduktdefinitionMatrisdata } from "./ProduktdefinitionMatrisdata";

export class ProduktdefinitionVardematrisdata {

    radprisUtgangsvarde: number;
    radprisLangdkorrektion: string;

    constructor(private readonly model: IProduktdefinition, readonly matrisdata: ProduktdefinitionMatrisdata) {
        this.radprisUtgangsvarde = this.model.radprisUtgangsvarde;
        this.radprisLangdkorrektion = this.model.radprisLangdkorrektion;
    }

    mapToDto(model: IProduktdefinition) {
        model.radprisUtgangsvarde = this.radprisUtgangsvarde;
        model.radprisLangdkorrektion = this.radprisLangdkorrektion;
    }
}
